import AuthContext from 'context/AuthContext';
import { t } from 'i18next';
import { startCase } from 'lodash';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import helper from 'utils/helpers';

function BasicInfo({ items }) {
  const location = useLocation();
  const { config, defaultCurrency } = useContext(AuthContext);
  return (
    <>
      <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
        <tbody>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Property Type
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.propertyType?.name}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Property Category
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.propertyCategory?.name}
            </th>
          </tr>
          {!location.pathname.includes('auction') && (
            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <th
                scope="row"
                className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
              >
                Agent
              </th>
              <th
                scope="row"
                className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
              >
                {items?.agent?.firstName
                  ? items?.agent?.firstName + ' ' + items?.agent?.lastName
                  : 'N/A'}
              </th>
            </tr>
          )}
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Bedrooms
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bedrooms === 0
                ? 'Studio'
                : items?.bedrooms === 8
                ? '7+'
                : !items?.bedrooms
                ? 'N/A'
                : items?.bedrooms}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Bathrooms
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bathrooms
                ? items?.bathrooms === 8
                  ? '7+'
                  : items?.bathrooms
                : 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Maids room
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.maidsRoom || ''}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Driver room
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.driverRoom || ''}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Furnished Type
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.furnished}
            </th>
          </tr>

          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Construction Status
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {startCase(items?.stage) || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Permit Number
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.permitNumber}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {t('REFERENCE_NUMBER')}
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.referenceNumber || 'N/A'}
            </th>
          </tr>
          {config?.country === 'Saudi' && (
            <>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Guest rooms
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.guestRooms
                    ? items?.guestRooms === 8
                      ? '7+'
                      : items?.guestRooms
                    : 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Living rooms
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.livingRooms
                    ? items?.livingRooms === 8
                      ? '7+'
                      : items?.livingRooms
                    : 'N/A'}
                </th>
              </tr>
            </>
          )}
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Title
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.title}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Title(Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.titleAr}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Slug
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.slug}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Slug(Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.slugAr}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Property Size
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.propertySize > 0 &&
                `${items?.propertySize} ${config?.areaUnit}`}
            </th>
          </tr>
          {(items?.propertyType?.slug === 'buy' ||
            items?.propertyType?.slug === 'commercial-buy') && (
            <>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Price
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.price > 0 && `${items?.price} ( ${defaultCurrency} )`}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Project status
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {startCase(items?.projectStatus) || 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Service charge
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {(items?.serviceCharge > 0 &&
                    `${items?.serviceCharge} ( ${defaultCurrency} )`) ||
                    'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Price per Unit
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {(items?.pricePerUnit > 0 &&
                    `${items?.pricePerUnit} ( ${defaultCurrency} )`) ||
                    'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Financial status
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.financialStatus || 'N/A'}
                </th>
              </tr>
            </>
          )}
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Amenities
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.amenities?.map((amenity) => amenity.name).join(', ')}
            </th>
          </tr>
          {(items?.propertyType?.slug === 'rent' ||
            items?.propertyType?.slug === 'commercial-rent') && (
            <>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Stage
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.stage ?? 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Cheques
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.cheques ?? 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Security deposits
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.securityDeposit ?? 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Price Daily
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.priceDaily
                    ? helper.priceFormat(items?.priceDaily) +
                      ' ' +
                      config?.currency
                    : 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Price Weekly
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.priceWeekly
                    ? helper.priceFormat(items?.priceWeekly) +
                      ' ' +
                      config?.currency
                    : 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Price Monthly
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.priceMonthly
                    ? helper.priceFormat(items?.priceMonthly) +
                      ' ' +
                      config?.currency
                    : 'N/A'}
                </th>
              </tr>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Price Yearly
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.priceYearly
                    ? helper.priceFormat(items?.priceYearly) +
                      ' ' +
                      config?.currency
                    : 'N/A'}
                </th>
              </tr>

              {/* <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
             Weekly price
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.priceWeekly}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
             Monthly price
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.priceMonthly}
            </th>
          </tr>
          <tr className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
             Yearly price
            </th>
            <th scope='row' className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'>
              {items?.priceYearly}
            </th>
          </tr> */}
            </>
          )}
          {(items?.property_type?.slug === 'commercial-buy' ||
            items?.property_type?.slug === 'commercial-rent') && (
            <>
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  Ready Stage
                </th>
                <th
                  scope="row"
                  className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                >
                  {items?.readyStage || 'N/A'}
                </th>
              </tr>{' '}
            </>
          )}

          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              BUA
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bua && `${items?.bua} sqrt`}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Parking type
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.parkingType || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Parking
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.parking || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Advertisement number
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.advert_type || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Advertisement number ( Arabic )
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.advert_typeAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Layout Type
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.layout_type || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Layout type (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.layout_typeAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              No of floors
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.no_of_floors}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Floor Number
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.floor_number}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Meta Title
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaTitle || 'N/A'}
            </th>
          </tr>

          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Meta Title (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaTitleAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Description
            </th>
            <th
              scope="row"
              dangerouslySetInnerHTML={{ __html: items?.description }}
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            />
            {/* {items?.description}
            </th> */}
          </tr>

          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Description (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.descriptionAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Meta Description
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaDescription || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Meta Description (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.metaDescriptionAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Keyword
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.keyword}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Keyword (Arabic)
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.keywordAr}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Owner Name
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.owner_name}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Owner Email
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.owner_email}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Owner Phone
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.owner_phone}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Agreement Status
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.agreementStatus}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Property Plan
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.propertyPlan?.lable || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Account Name
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.accountName || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Account Name Arabic
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.accountNameAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Bank Name
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bankName || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Bank Name Arabic
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.bankNameAr || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              IBAN
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {items?.iban || 'N/A'}
            </th>
          </tr>
          <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              Down Payment Percentage
            </th>
            <th
              scope="row"
              className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
            >
              {`${items?.downPaymentPercentage}%` || 'N/A'}
            </th>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default BasicInfo;
